import Vue from 'vue';

export default [
    {
        pathId: 'cs',
        component: 'courses',
        title: 'Courses',
        icon: 'fa-chalkboard-teacher',
        size: 'sm',
        loading: true
    }, {
        pathId: 'c',
        component: 'course',
        title: 'Course',
        icon: 'fa-chalkboard-teacher',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'cens',
        component: 'enrollments',
        title: 'Course Enrollments',
        icon: 'fa-users',
        size: 'md',
        props: ['courseId', 'type'],
        loading: true
    }, {
        pathId: 'cenq',
        component: 'enrollment-search',
        title: 'Enrollment Search',
        icon: 'fa-search',
        size: 'sm',
        props: ['query', 'courseId', 'type'],
        loading: true
    }, {
        pathId: 'cers',
        component: 'all-responses',
        title: 'Enrollment Course Responses',
        icon: 'fa-comments',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'cedrs',
        component: 'all-responses-data',
        title: 'Responses',
        icon: 'fa-keyboard',
        size: 'md',
        props: ['courseId', 'inputId'],
        loading: true
    }, {
        pathId: 'cen',
        component: 'enrollment',
        title: 'Enrollment',
        icon: 'fa-user',
        size: 'md',
        props: ['enrollId', 'courseId'],
        loading: true
    }, {
        pathId: 'cend',
        component: 'enrollment-data',
        title: 'Course Responses',
        icon: 'fa-comment',
        size: 'md',
        props: ['enrollId', 'courseId'],
        loading: true
    }, {
        pathId: 'cn',
        component: 'new-course',
        title: 'New Course',
        icon: 'fa-plus',
        size: 'md'
    }, {
        pathId: 'ce',
        component: 'edit-course',
        title: 'Edit Course',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'ceo',
        component: 'course-outline',
        title: 'Course Outline',
        icon: 'fa-list-alt',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'ecs',
        component: 'edit-section',
        title: 'Section Outline',
        icon: 'fa-list',
        size: 'md',
        props: ['courseId', 'outlineId', 'sectionId'],
        loading: true
    }, {
        pathId: 'cnsc',
        component: 'new-section-component',
        title: 'New Component',
        icon: 'fa-pencil',
        size: 'md',
        props: ['sectionId'],
    }, {
        pathId: 'cpv',
        component: 'view-component',
        title: 'View',
        icon: 'fa-chalkboard-teacher',
        size: 'xl',
        props: ['courseId', 'componentId'],
        loading: true
    }, {
        pathId: 'coie',
        component: 'edit-outline-item',
        title: 'Edit Outline Item',
        icon: 'fa-pencil',
        size: 'md',
        props: ['courseId', 'outlineId'],
        loading: true
    }, {
        pathId: 'crie',
        component: 'edit-required-item',
        title: 'Edit Required Component',
        icon: 'fa-pencil',
        size: 'md',
        props: ['courseId', 'requiredId'],
        loading: true
    }, {
        pathId: 'cas',
        component: 'course-applications',
        title: 'Certification Applications',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'ca',
        component: 'course-app',
        title: 'Application',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['courseId', 'appId'],
        loading: true
    }, {
        pathId: 'cae',
        component: 'course-edit-app',
        title: 'Edit Certification Application',
        icon: 'fa-file-certificate',
        size: 'md',
        props: ['courseId', 'appId'],
        loading: true
    }, {
        pathId: 'ccfgs',
        component: 'course-configs',
        title: 'Enrollment Options',
        icon: 'fa-sliders',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'ccfgn',
        component: 'course-new-config',
        title: 'New Enrollment Option',
        icon: 'fa-plus',
        size: 'md',
        props: ['courseId'],
        loading: true
    }, {
        pathId: 'ccfge',
        component: 'course-edit-config',
        title: 'Edit Enrollment Option',
        icon: 'fa-pencil',
        size: 'md',
        props: ['courseId', 'configId'],
        loading: true
    }
];

Vue.component('courses', () => import('@/cards/courses/Courses'));
Vue.component('course', () => import('@/cards/courses/Course'));
Vue.component('enrollments', () => import('@/cards/courses/enrollments/Enrollments'));
Vue.component('enrollment-search', () => import('@/cards/courses/enrollments/Search'));
Vue.component('all-responses', () => import('@/cards/courses/enrollments/Responses'));
Vue.component('all-responses-data', () => import('@/cards/courses/enrollments/AllData'));
Vue.component('enrollment', () => import('@/cards/courses/enrollments/Enrollment'));
Vue.component('enrollment-data', () => import('@/cards/courses/enrollments/Data'));
Vue.component('new-course', () => import('@/cards/courses/NewCourse'));
Vue.component('edit-course', () => import('@/cards/courses/EditCourse'));
Vue.component('course-outline', () => import('@/cards/courses/Outline'));
Vue.component('edit-section', () => import('@/cards/courses/EditSection'));
Vue.component('new-section-component', () => import('@/cards/courses/NewComponent'));
Vue.component('view-component', () => import('@/cards/courses/View'));
Vue.component('edit-outline-item', () => import('@/cards/courses/EditOutlineItem'));
Vue.component('edit-required-item', () => import('@/cards/courses/EditRequiredItem'));
Vue.component('course-applications', () => import('@/cards/courses/applications/Applications'));
Vue.component('course-app', () => import('@/cards/courses/applications/Application'));
Vue.component('course-edit-app', () => import('@/cards/courses/applications/EditApplication'));
Vue.component('course-configs', () => import('@/cards/courses/configs/Configs'));
Vue.component('course-new-config', () => import('@/cards/courses/configs/NewConfig'));
Vue.component('course-edit-config', () => import('@/cards/courses/configs/EditConfig'));
